<template>
  <div class='c-content__imageBlockBg'>
    <div class="c-standard" style='padding: 0 0 15px'>
      <h3 class='title_h3 relative'>
        <span>{{ content.title }}</span>
        <div class="textBgLeft absolute" style='height: 700%'></div>
      </h3>
    </div>

    <div class="c-content__imageBlockBg--bg" :style="{backgroundImage:'url('+ content.img +')'}">
      <div class="c-standard relative">
        <div class="c-content__imageBlockBg--text" :style="{backgroundImage:'url('+ content.img +')'}">
          <h4>
            <i>{{ text.no }}</i>
            <p>{{ text.title }}</p>
          </h4>
          <span>{{ text.content }}</span>

        </div>
        <div class="c-content__imageBlockBg--btns">
          <div class="c-content__imageBlockBg--btn" :class="{'is-active': index == active}" v-for="(item, index) in items" :key="index" @click="showText(item, index)">
            <h4>
              <i>{{ item.no }}</i>
              <p>{{ item.title }}</p>
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'imageBlockBg',
    data(){
      return{
        content:{
          title: this.$t('homepage.imageBgBlock.title'),
          img: require('../../assets/img/pic_hands.jpg'),
        },
        text:{
          no: '01',
          title: this.$t('homepage.imageBgBlock.items.item1.title'),
          content: this.$t('homepage.imageBgBlock.items.item1.content')
        },
        items: [
          {no: '01', title: this.$t('homepage.imageBgBlock.items.item1.title'), content: this.$t('homepage.imageBgBlock.items.item1.content')},
          {no: '02', title: this.$t('homepage.imageBgBlock.items.item2.title'), content: this.$t('homepage.imageBgBlock.items.item2.content')},
          {no: '03', title: this.$t('homepage.imageBgBlock.items.item3.title'), content: this.$t('homepage.imageBgBlock.items.item3.content')},
          {no: '04', title: this.$t('homepage.imageBgBlock.items.item4.title'), content: this.$t('homepage.imageBgBlock.items.item4.content')},
          {no: '05', title: this.$t('homepage.imageBgBlock.items.item5.title'), content: this.$t('homepage.imageBgBlock.items.item5.content')},
          {no: '06', title: this.$t('homepage.imageBgBlock.items.item6.title'), content: this.$t('homepage.imageBgBlock.items.item6.content')},
          {no: '07', title: this.$t('homepage.imageBgBlock.items.item7.title'), content: this.$t('homepage.imageBgBlock.items.item7.content')},
          {no: '08', title: this.$t('homepage.imageBgBlock.items.item8.title'), content: this.$t('homepage.imageBgBlock.items.item8.content')},
          {no: '09', title: this.$t('homepage.imageBgBlock.items.item9.title'), content: this.$t('homepage.imageBgBlock.items.item9.content')},
          {no: '10', title: this.$t('homepage.imageBgBlock.items.item10.title'), content: this.$t('homepage.imageBgBlock.items.item10.content')},
        ],
        active: 0
      }
    },
    computed: {

    },
    methods:{
      showText(item, index){
        this.text = item
        this.active = index
      }
    },
    created(){

    }
  }
</script>

<style>


</style>
